import { useState } from 'react';
import { Box, Tabs, Tab, Link } from '@mui/material';
import { useQuery } from 'react-query';
import axiosClient from '../../../../../../../lib/axios';
import LoadingApiQuery from '../../../../../../../components/LoadingApiQuery';

export default function Categorias({ onCategoriaClick }: CategoriasProps) {
    const [selectedTab, setSelectedTab] = useState(0);

    // Buscar categorias da API
    const { data: categorias, isLoading } = useQuery<ICategoriaResponse[]>({
        queryKey: ['/comercial/pedidos/pesquisar-categorias'],
        queryFn: () => axiosClient.get('/comercial/pedidos/pesquisar-categorias').then(res => res.data),
    });

    const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
        setSelectedTab(newValue);
    };

    if (isLoading) {
        return <LoadingApiQuery />;
    }

    return (
        <Box sx={{ width: '100%', mb: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs 
                    value={selectedTab} 
                    onChange={handleTabChange}
                    variant="scrollable"
                    scrollButtons="auto"
                    TabIndicatorProps={{
                        style: { backgroundColor: '#2e7d32' }
                    }}
                >
                    {categorias?.map((categoria, index) => (
                        <Tab 
                            key={categoria.id} 
                            label={categoria.nome} 
                            value={index}
                            sx={{
                                color: 'text.primary',
                                '&.Mui-selected': {
                                    color: '#2e7d32',
                                    fontWeight: 'bold'
                                }
                            }}
                        />
                    ))}
                </Tabs>
            </Box>

            {categorias?.map((categoria, index) => (
                <Box
                    key={categoria.id}
                    role="tabpanel"
                    hidden={selectedTab !== index}
                >
                    {selectedTab === index && (
                        <Box sx={{ 
                            mt: 3,
                            columnCount: 3,
                            columnGap: '48px',
                            '& > *': {
                                breakInside: 'avoid',
                                marginBottom: '32px'
                            }
                        }}>
                            {categoria.subcategorias.map((subcat) => (
                                <Box key={subcat.id}>
                                    <Link 
                                        onClick={() => onCategoriaClick?.(
                                            subcat.id, 
                                            `${categoria.nome} » ${subcat.nome}`
                                        )}
                                        sx={{
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        {subcat.nome}
                                    </Link>
                                    
                                    {subcat.subcategorias?.length > 0 && (
                                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, marginTop: 1 }}>
                                            {subcat.subcategorias.map((subsubcat) => (
                                                <Link
                                                    key={subsubcat.id}
                                                    onClick={() => onCategoriaClick?.(
                                                        subsubcat.id,
                                                        `${categoria.nome} » ${subcat.nome} » ${subsubcat.nome}`
                                                    )}
                                                    sx={{
                                                        marginLeft: 2,
                                                        cursor: 'pointer'
                                                    }}
                                                >
                                                    {subsubcat.nome}
                                                </Link>
                                            ))}
                                        </Box>
                                    )}
                                </Box>
                            ))}
                        </Box>
                    )}
                </Box>
            ))}
        </Box>
    );
}


interface ICategoriaResponse {
    id: number;
    nome: string;
    subcategorias: {
        id: number;
        nome: string;
        subcategorias: {
            id: number;
            nome: string;
        }[];
    }[];
}

interface CategoriasProps {
    onCategoriaClick?: (id: number, hierarquia: string) => void;
}